<template>
    <MaterialInventory></MaterialInventory>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const MaterialInventory = defineAsyncComponent(() =>
    import("../../components/CNC/MaterialInventory.vue")
);

export default {
    name: "Material_Inventory", //The name you are in should not equal the name of the component you are importing.
    components: { MaterialInventory, AuthLayout },
};
</script>
